import { render } from "./ScoreComponent.vue?vue&type=template&id=519a852d&scoped=true&ts=true"
import script from "./ScoreComponent.vue?vue&type=script&lang=ts"
export * from "./ScoreComponent.vue?vue&type=script&lang=ts"

import "./ScoreComponent.vue?vue&type=style&index=0&id=519a852d&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/SurveyPublic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-519a852d"]])

export default __exports__